import { render } from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=template&id=030f3c1d"
import script from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=script&lang=js"
export * from "./VPAAStaffRepUnitLoadingDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__